import { ActuatorCommandPatch as _ActuatorCommandPatch, ActuatorCommandPatchDeactivate  } from "generated/models";
import { LdsApp } from "./Ldsu";

export type ActuatorCommand = _ActuatorCommandPatch & {
    activate_ts?: number;
};

export type LdsActuator = {
    UID: string;
    OBJ: string;
    SAID: number | number[];
    sensor_name: string[];
    CMDS: ActuatorCommand[];
    timestamp: number;
    status: number[];
    APP: LdsApp[] | null;
};

export type LdsActuatorDetails = LdsActuator & {
    name: string;
    type: string;
    info: ActuatorCommand;
    said: number;
    CLS: string;
    appId?: string;
};

export enum ActuatorCommandMode {
    LEVEL = "LEVEL",
    PULSE = "PULSE",
    LOOP = "LOOP",
    PWM = "PWM",
    ANALOG = "ANALOG",
    MOTOR = "MOTOR",
    MANUAL = "MANUAL",
    AUTO = "AUTO",
}

export type ActuatorTiming = Array<[number, number]>;

export type Actuator =  {
    name: string;
    mode: ActuatorCommandMode;
    auto: boolean;
    polarity?: boolean;
    deactivate?: ActuatorCommandPatchDeactivate;
    cycle_count?: number;
    timing?: ActuatorTiming;
    activate_value?: number;
    deactivate_value?: number;
    isAnalog?: boolean;
    value?: number;
};
export interface ModeConfigs {
    [key: string]: {};
}